export default class Header {
  /*
   * Fires first
   */
  constructor() {
    // Add events
    this.addEvents();
  }

  /*
   * Add events
   */
  addEvents() {
    //Toggle mobile menu
    $('.js-header__mobile-menu').on('click', e => {
      // $(e.currentTarget).toggleClass('header__mobile-menu--active');
      $(e.currentTarget).toggleClass('is-active');

      $('.js-header__mobile-menu-toggle').slideToggle();
    });

    //Toggle Languages list
    $('.js-header__language-button').on('click', e => {
      // e.preventDefault();
      $('.js-header__language-list').toggle();
    });

    //Toggle Search bar
    $('.js-header__search-icon').on('click', e => {
      $('.js-header__search-bar').slideToggle();
    });

    //Toggle Select country
    $('.js-header__select-country').on('change', e => {
      $('.js-header__select-language').empty();
      const languages = JSON.parse( $(e.currentTarget).val() );

      for (const key in languages){
        if(languages[key]){
          var removeBrackets = languages[key].translated_name.replace(/ *\([^)]*\) */g, "");
          $('.js-header__select-language').append( '<option value="'+languages[key].code+'">'+removeBrackets+'</option>' );
        }
      }
    });

    //Submit change language
    $('.js-header__submit-language').on('click', e => {
      let currentUrl = document.location.toString();
      let toTranlsate = $('.js-header__select-language').val();
      //Ajax call to get the current url in a differen language
      $.ajax({
        type: 'GET',
        url: ajaxObject.ajax_url,
        dataType: "json",
        data: {
            action: 'getTranslatedUrl',
            toTranlsate: toTranlsate,
            currentUrl: currentUrl,
        },
        success: (result) => {

          //Redirect user to new language
          if( result.data.url ){
            window.location.href = result.data.url;
            return false;
          }

        },
      });
    });






  }
}
